import API from "$vueCommon/classes/API.js";

export default class CountryAPI extends API {

    static data = new Map();
    static promise = null;

    static getCountries() {
        if (this.data.size > 0) {
            return new Promise(resolve => {
                resolve(this.data);
            });
        }

        if (this.promise) {
            return this.promise;
        }

        this.promise = new Promise((resolve, reject) => {
            this.get('/api/countries/getCountries').then(response => {
                for (const country of response.data) {
                    this.data.set(country.id, country);
                }
                resolve(this.data);
            }, reject => {
                reject(data);
            });
        });

        return this.promise;
    }

    static getCountryName(countryId) {
        const country = this.data.get(countryId);
        if (country) {
            return country.name;
        }

        return false;
    }

    static getCountry(countryId) {
        return this.data.get(countryId);
    }

    static toArray() {
        return Array.from(this.data, ([name, value]) => (value));
    }
}
